planner-tooltip-detail
  .details.clearfix
    span.detail
      span.index.label.label-inverse-success(style="{ this.indexStyle }") {opts.locale.labels.responsible_name}
      span.value(if="{ ttData.responsible_name}") { ttData.responsible_name }
      span.value(if="{!ttData.responsible_name}") { opts.locale.nodata.responsible }
    span.detail(if="{ttData.phaseData.identity == 'delivery'}")
      span.index.label.label-inverse-success(style="{ this.indexStyle }") {opts.locale.labels.location_name}
      span.value(if="{ ttData.location_name}") { ttData.location_name }
      span.value(if="{!ttData.location_name}") { opts.locale.nodata.location }
    span.detail(if="{ttData.day_memo}")
      span.index.label.label-inverse-success(style="{ this.indexStyle }") {opts.locale.labels.day_memo}
      span.value { ttData.day_memo }
    span.detail(if="{ttData.memo}")
      span.index.label.label-inverse-success(style="{ this.indexStyle }") {opts.locale.labels.memo}
      span.value { ttData.memo }
  script(type="typescript").
    this.mixin('orders.planner.tooltip.detail')
